module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'InvoiceList'
      }
    }
  }, [_vm._v("Faktury sprzedażowe")]), _vm._v("/"), (_vm.item && !_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.item.fullNumber))]) : _vm._e()], 1), _vm._v(" "), (_vm.item && !_vm.loading) ? _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'InvoiceUpdate',
        params: {
          id: _vm.item.id
        }
      },
      "title": "Edytuj"
    }
  }, [_c('span', [_vm._v("Edytuj")]), _c('svg-icon', {
    attrs: {
      "name": "edit"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.downloadFile(_vm.item.activeDocumentID)
      }
    }
  }, [_c('span', [_vm._v("Pobierz")]), _c('svg-icon', {
    attrs: {
      "name": "download"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#",
      "title": "Podgląd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.previewFile(_vm.item.activeDocumentID)
      }
    }
  }, [_c('span', [_vm._v("Podgląd")]), _c('svg-icon', {
    attrs: {
      "name": "preview"
    }
  })], 1), _vm._v(" "), (_vm.item.correctingInvoiceId) ? _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'InvoiceShow',
        params: {
          id: _vm.item.correctingInvoiceId
        }
      },
      "title": "Korekta"
    }
  }, [_c('span', [_vm._v("Korekta")]), _c('svg-icon', {
    attrs: {
      "name": "correction"
    }
  })], 1) : _c('router-link', {
    staticClass: "btn btn-info",
    attrs: {
      "to": {
        name: 'InvoiceCreate',
        query: {
          correction: _vm.item.id
        }
      },
      "title": "Korekta"
    }
  }, [_c('span', [_vm._v("Korekta")]), _c('svg-icon', {
    attrs: {
      "name": "correction"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#",
      "title": "usuń"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteItem($event)
      }
    }
  }, [_c('span', [_vm._v("Usuń")]), _c('svg-icon', {
    attrs: {
      "name": "minus"
    }
  })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.createdShowMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Faktura została zapisana")]) : _vm._e(), _vm._v(" "), (_vm.updatedShowMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Faktura została zmodyfikowana")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.deleteError) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Nie udało się usunąć faktury. Aby usunięcie faktury było możliwe faktura nie może posiadać korkety")]) : _vm._e(), _vm._v(" "), (_vm.loading || _vm.delLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading && !_vm.delLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Numer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.fullNumber))])]), _vm._v(" "), (_vm.item.correction) ? _c('tr', [_c('td', [_vm._v("Korekta do faktury")]), _vm._v(" "), _c('td', [_c('router-link', {
    attrs: {
      "to": {
        name: 'InvoiceShow',
        params: {
          id: _vm.item.correctedInvoice.id
        }
      },
      "title": "Korekta"
    }
  }, [_vm._v(_vm._s(_vm.item.correctedInvoice.fullNumber))])], 1)]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading && !_vm.delLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_vm._v("Nabywca")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Nazwa")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.customerData.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("NIP")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.customerData.nip))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("REGON")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.customerData.regon))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Adres")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.customerData.customerAddress.postalCode) + " " + _vm._s(_vm.item.customerData.customerAddress.city) + ", ul. " + _vm._s(_vm.item.customerData.customerAddress.street) + " " + _vm._s(_vm.item.customerData.customerAddress.number) + " " + _vm._s(_vm.item.customerData.customerAddress.country))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_vm._v("Dane faktury")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Data wystawienia")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.item.createDate)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Data zakończenia")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.item.endDate)))])]), _vm._v(" "), (_vm.item.paymentDate) ? _c('tr', [_c('td', [_vm._v("Termin zapłaty")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(_vm.item.paymentDate)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Waluta")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.currency.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sposób płatności")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.paymentType.name))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Status")]), _vm._v(" "), _c('td', [(_vm.item['paid']) ? _c('span', {
    staticClass: "element_status closed"
  }, [_vm._v("Zapłacona")]) : _vm._e(), _vm._v(" "), (!_vm.item['paid'] && !_vm.item['deducted']) ? _c('span', {
    staticClass: "element_status open"
  }, [_vm._v("Niezapłacona")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Uwagi")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.comments))])])])])])]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading && !_vm.delLoading && _vm.item.correction) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_vm._v("Towary/usługi - było")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-invoices"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("L.p.")]), _vm._v(" "), _c('th', [_vm._v("Nazwa towaru/usługi")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Jm")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Ilość")]), _vm._v(" "), _c('th', [_vm._v("Cena netto")]), _vm._v(" "), _c('th', [_vm._v("Wartość netto")]), _vm._v(" "), _c('th', [_vm._v("Stawka VAT")]), _vm._v(" "), _c('th', [_vm._v("VAT")]), _vm._v(" "), _c('th', [_vm._v("Wartość brutto")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.item.correctedInvoiceItems), function(item, index) {
    return _c('InvoiceItem', {
      attrs: {
        "values": item,
        "index": index
      }
    })
  }), 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.item && !_vm.loading && !_vm.delLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-data"
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('h3', [_vm._v("Towary/usługi"), (_vm.item.correction) ? _c('span', [_vm._v(" - powinno być")]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-invoices"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("L.p.")]), _vm._v(" "), _c('th', [_vm._v("Nazwa towaru/usługi")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Jm")]), _vm._v(" "), _c('th', {
    staticClass: "th-narrow"
  }, [_vm._v("Ilość")]), _vm._v(" "), _c('th', [_vm._v("Cena netto")]), _vm._v(" "), _c('th', [_vm._v("Wartość netto")]), _vm._v(" "), _c('th', [_vm._v("Stawka VAT")]), _vm._v(" "), _c('th', [_vm._v("VAT")]), _vm._v(" "), _c('th', [_vm._v("Wartość brutto")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.item.items), function(item, index) {
    return _c('InvoiceItem', {
      attrs: {
        "values": item,
        "index": index
      }
    })
  }), 1), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "text-right td-no_link",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("Suma:")]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.item.amount)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.item.taxAmount)))]), _vm._v(" "), _c('td', {
    staticClass: "td-no_link"
  }, [_vm._v(_vm._s(_vm._f("amountFormat")(_vm.item.grossAmount)))])])])])])])])]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51b2373e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/Show.vue
// module id = 815
// module chunks = 0